import React, { useState } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  flexRender,
} from "@tanstack/react-table";
import { round } from "@turf/turf";

const columnHelper = createColumnHelper();

const EquipmentTable = ({ rowInfo, appUnit, equipmentClick }) => {
  const columns = [
    columnHelper.accessor(
      (row) => {
        switch (row.statusEquipment) {
          case 1:
            return "🟢 Moving";
          case 2:
            return "🟡 Idling";
          case 3:
            return "🔴 Parked";
          case 4:
            return "🔵 Pending";
          case 5:
            return "⚪ Offline";
          default:
            return "⚪ Other";
        }
      },
      {
        id: "Status",
        header: "State",
        size: 100,
      },
    ),
    columnHelper.accessor((row) => row?.name, {
      id: "Equipment",
      header: "ID",
      size: 80,
    }),
    columnHelper.accessor((row) => row?.statusTum, {
      id: "Tum Status",
      header: "Status",
      size: 80,
    }),
    columnHelper.accessor((row) => row?.variables?.Operator?.value, {
      id: "Driver Name",
      header: "Operator Name",
      size: 125,
    }),

    columnHelper.accessor(
      (row) => (row.errorDatetime == true ? "-" : row.utcHourDatetime),
      {
        id: "Last Seen",
        header: "Last Seen",
        size: 100,
      },
    ),
    columnHelper.accessor(
      (row) => {
        if (row.statusEquipment === 5) return "-";
        const speedEquipment = row.velocity.groundSpeed;

        if (appUnit === "imperial") {
          // 1 m/s = 2.23694 mi/h
          return Math.round(speedEquipment * 2.237) + " mi/h";
        } else {
          // 1 m/s = 3.6 km/h
          return Math.round(speedEquipment * 3.6) + " km/h";
        }
      },
      {
        id: "Speed",
        header: "Speed",
        size: 70,
      },
    ),
    columnHelper.accessor((row) => row.typeEquipment, {
      id: "Type",
      header: "Type",
      size: 55,
    }),
    columnHelper.accessor(
      (row) =>
        row.errorDatetime == true ? "-" : row.deviceActivityHourDatetime,
      {
        id: "Last Connection",
        header: "Last Connection",
        size: 122,
      },
    ),

    columnHelper.accessor(
      (row) => round(row?.variables?.ExternalVoltage?.value ?? 0, 1),
      {
        id: "External Voltage",
        header: "Battery (V)",
        size: 90,
      },
    ),
  ];

  const [sorting, setSorting] = useState([]);

  const [columnOrder, setColumnOrder] = useState(columns.map((c) => c.id));
  //console.log('LOG OPERATOR TABLE Main: ', rowInfo);

  const table = useReactTable({
    data: rowInfo ?? [],
    columns,
    state: {
      sorting,
      columnOrder,
    },
    onSortingChange: setSorting,
    onColumnOrderChange: setColumnOrder,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <div className="p-1  h-full overflow-y-auto">
      <table className="border w-full table-fixed">
        <thead className="bg-gray-300">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  style={{ width: header.getSize() }}
                  className="relative border p-1 text-left text-xs truncate"
                >
                  <div
                    onClick={header.column.getToggleSortingHandler()}
                    className="cursor-pointer"
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
                    {{
                      asc: " ↑",
                      desc: " ↓",
                    }[header.column.getIsSorted()] ?? null}
                  </div>

                  {/* Resize handle */}
                  <div
                    onMouseDown={header.getResizeHandler()}
                    className="absolute right-0 top-0 h-full w-1 cursor-col-resize bg-transparent hover:bg-blue-400"
                  />
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr
              key={row.id}
              className="hover:bg-white"
              onClick={() => equipmentClick(row)}
            >
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} className="border p-1 text-xs truncate">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EquipmentTable;
